import { render, staticRenderFns } from "./ApiKeyAccess.vue?vue&type=template&id=85df0406&scoped=true&"
import script from "./ApiKeyAccess.vue?vue&type=script&lang=js&"
export * from "./ApiKeyAccess.vue?vue&type=script&lang=js&"
import style0 from "./ApiKeyAccess.vue?vue&type=style&index=0&id=85df0406&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85df0406",
  null
  
)

export default component.exports